import { inject, Injectable } from '@angular/core';

import {
  DashboardResponse,
  loginAndGetDashboardResponse
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  CompanyDescription,
  URL
} from '../models/profile-selector-aem.interface';

import {
  APP_BUSINESS_OA_SME_ACCOUNTS,
  CorpAgreementData,
  PROGRAM_TYPE
} from '../constants/profile-selector-constants';
import { getCorporatePartner } from '../utils/corporate-method/corporate-partner.method';
import { ProfileSelectorUtilService } from '../utils/profile-selector-util.service';
import { SkyBonusNuTravelAdapterService } from './skybonus-nutravel-adapter/skybonus-nutravel-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorAdapterHelperSupportExtendedService {
  url = {} as URL;
  oaSmeAccountCode = '';
  crprtAgrmntId: string[] | '' = '';
  pgmType: string[] | '' = '';
  crprtAgrmntTypeCode: string[] | '' = '';
  program: string[] | '' = '';
  corpType: string[] | undefined = [];
  companyName: string[] | undefined = [];
  title = {} as CompanyDescription;
  companyDescription = {} as CompanyDescription;
  dashboardResponse = {} as
    | Partial<DashboardResponse>
    | loginAndGetDashboardResponse;

  profileSelectorUtilService = inject(ProfileSelectorUtilService);
  skyBonusNuTravelAdapterService = inject(SkyBonusNuTravelAdapterService);

  isCorpAgreeIdPresent(corporateAgreementIdList: string): boolean {
    return !!corporateAgreementIdList && corporateAgreementIdList !== 'NA';
  }

  isOaSME(
    companyName: string,
    isCorporateAgreementIdPresent: boolean
  ): {
    isOaSmeAccount: boolean;
  } {
    const isOaSMEObject = {
      isOaSmeAccount: false
    };
    this.oaSmeAccountCode = APP_BUSINESS_OA_SME_ACCOUNTS;
    const companyCodeForOaSmeList = this.oaSmeAccountCode.split(',');
    companyCodeForOaSmeList.forEach((OaSMECompanyCode: string) => {
      if (companyName === OaSMECompanyCode && isCorporateAgreementIdPresent) {
        return (isOaSMEObject.isOaSmeAccount = true);
      } else return isOaSMEObject;
    });
    return isOaSMEObject;
  }

  // eslint-disable-next-line complexity
  getBusinessOptions(
    option: string,
    corporateAgreementTypeCode: string,
    corporateAgreementId: boolean,
    programType: string,
    program: string,
    isOaSme: boolean
  ): boolean | string | undefined {
    const partnerName = this.mapCorporatePartnerName(
      corporateAgreementTypeCode,
      corporateAgreementId,
      programType,
      program,
      isOaSme
    );

    switch (option) {
      case 'restrictOnePax':
        return getCorporatePartner(partnerName).restrictPaxToOne;
      case 'disableMiles':
        return getCorporatePartner(partnerName).disableMiles;
      case 'displayInlineText':
        return getCorporatePartner(partnerName).displayInlineText;
      case 'partnerId':
        return getCorporatePartner(partnerName).name;
      default:
        return undefined;
    }
  }

  // eslint-disable-next-line complexity
  mapCorporatePartnerName(
    corporateAgreementTypeCode: string,
    corporateAgreementId: boolean,
    programType: string,
    program: string,
    isOaSme: boolean
  ): string {
    const corpAgreementData = CorpAgreementData;
    switch (corporateAgreementTypeCode) {
      case corpAgreementData['edp']:
      case corpAgreementData['edpCna']:
        return 'edp';
      case corpAgreementData['concur']:
      case corpAgreementData['concurold']:
        return corporateAgreementId ? 'concur-spid' : 'concur-no-spid';
      case corpAgreementData['nutravel']:
        switch (programType) {
          case corpAgreementData['corporateRewards']:
            return program === PROGRAM_TYPE.SKYB
              ? 'nutravel-skyb'
              : 'nutravel-sme';
          case corpAgreementData['noprogram']:
            return 'nutravel-no-program';
          default:
            return 'nutravel-spid';
        }
      case corpAgreementData['sme']:
        if (program === PROGRAM_TYPE.SKYB) return 'standalone-sky-skyb';
        return isOaSme ? 'standalone-oa-sme' : 'standalone-sky';
      default:
        return 'personal';
    }
  }

  getBusinessOption(
    option: string,
    index: number,
    cpAgtId: boolean,
    isOaSmeAccount: boolean
  ): boolean | string | undefined {
    return this.getBusinessOptions(
      option,
      this.crprtAgrmntTypeCode[index],
      cpAgtId,
      this.pgmType[index],
      this.program[index],
      isOaSmeAccount
    );
  }
}
